module.exports = require("stream");


/*****************
 ** WEBPACK FOOTER
 ** external "stream"
 ** module id = 50
 ** module chunks = 0
 **/